import api from './api';

const tarificationService = {
  // Get all tarifications
  getTarifications: async (params = {}) => {
    try {
      const response = await api.get('/tarifications', { params });
      return response.data;
    } catch (error) {
      console.error('Error fetching tarifications:', error);
      throw error;
    }
  },

  // Get tarification by ID
  getTarificationById: async (id) => {
    try {
      const response = await api.get(`/tarifications/${id}`);
      return response.data;
    } catch (error) {
      console.error(`Error fetching tarification ${id}:`, error);
      throw error;
    }
  },

  // Create new tarification
  createTarification: async (tarificationData) => {
    try {
      const response = await api.post('/tarifications', tarificationData);
      return response.data;
    } catch (error) {
      console.error('Error creating tarification:', error);
      throw error;
    }
  },

  // Update tarification
  updateTarification: async (id, tarificationData) => {
    try {
      const response = await api.put(`/tarifications/${id}`, tarificationData);
      return response.data;
    } catch (error) {
      console.error(`Error updating tarification ${id}:`, error);
      throw error;
    }
  },

  // Delete tarification
  deleteTarification: async (id) => {
    try {
      const response = await api.delete(`/tarifications/${id}`);
      return response.data;
    } catch (error) {
      console.error(`Error deleting tarification ${id}:`, error);
      throw error;
    }
  },

  // Show all tarifications
  showAllTarifications: async () => {
    try {
      const response = await api.get('/tarification/ShowAll');
      return response.data;
    } catch (error) {
      console.error('Error fetching all tarifications:', error);
      throw error;
    }
  },

  // Search tarification by client and departure
  searchTarificationByClient: async (clientId, departure) => {
    try {
      const response = await api.get(`/tarification/sreachTraficationByClient/${clientId}/${departure}`);
      return response.data;
    } catch (error) {
      console.error('Error searching tarification:', error);
      throw error;
    }
  }
};

export default tarificationService;